import React from 'react';

/*
  Propiedades del piso: franja compacta (sin tarjetas), inspirada en los sellos del empaque
  pero sin copiar sus leyendas. Se renderiza antes de la composición del piso.
  Sin imágenes: iconos Font Awesome y un numeral tipográfico para la garantía.
*/
const PROPIEDADES = [
  { icono: 'fa-droplet', texto: 'Impermeable' },
  { icono: 'fa-leaf', texto: 'Libre de ftalatos' },
  { icono: 'fa-certificate', texto: 'Certificación FloorScore®' },
  { numero: '10', texto: 'años de garantía comercial limitada' },
  { icono: 'fa-recycle', texto: 'Vinil virgen reutilizable' },
];

const SellosSpcPremium = () => {
  return (
    <div className="container">
      <div className="spc-seals wow fadeIn" data-wow-delay="200ms">
        <h3 className="spc-seals__title">Propiedades del Piso SPC Luxury</h3>
        <ul className="spc-seals__list">
          {PROPIEDADES.map(({ icono, numero, texto }) => (
            <li className="spc-seals__item" key={texto}>
              {numero ? (
                <span className="spc-seals__glyph spc-seals__glyph--num">{numero}</span>
              ) : (
                <i className={`fa-solid ${icono} spc-seals__glyph`} aria-hidden="true"></i>
              )}
              <span className="spc-seals__txt">{texto}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SellosSpcPremium;